
export class CompanyIdRequest {
    companyId: number;
    username?: string;

    constructor(companyId: number, username?: string) {
        this.companyId = companyId;
        this.username = username;
    }
}